export const MIN_RANGE_SELECT_VALUE = 0;
export const MAX_RANGE_SELECT_VALUE = 999_999_999_999;

export const INFINITY_CHARACTER_CODE = 8734; // ∞ character decimal code

export const DYNAMIC_LIST_SEARCH_MIN_ITEMS = 10;
